module.exports = __webpack_public_path__ + "img/Rich_Morris@2x.28adb30e.png";